export default __webpack_public_path__ + "static/media/ellipse4.92e351af.svg";